// extracted by mini-css-extract-plugin
export default {"table":"Table_table__FIvA6","lightGrey":"Table_lightGrey__gF4tl"};